<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.name}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
              <div>
                <span>{{$t("reservation.result")}}</span>
                <span class="ressquareBox">{{ v.size }}</span>
                <span class="ressquareBox">{{ v.double }}</span>
              </div>
            </div>
          </div>

          <div>
            <van-row>
              <van-col span="4.5"><span style="display: inline-block;">{{$t("reservation.selected")}}</span></van-col>
              <van-col  v-for="(u,key) in v.data" :key="'num-'+key"  span="5.2" style="display: flex; flex-direction: column; align-items: center;">
                <span class="ressquareText">{{ u.type=='big'?rose:u.type=='small'?lily:u.type=='one'?fireworks:balloon }}</span>
                <span style="text-align: center; margin-top: 1px;margin-left: 10px;font-size: 16px; font-weight: 500;">{{ u.money }}</span>
              </van-col>
            </van-row>
          </div>
          <div class="topInfo">

<!--            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>-->
<!--            <span v-else>{{v.status_text}}</span>-->
            <span>{{$t("reservation.money")}}：{{v.money}}</span>

          </div>
       <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      size: "",
      rose: '',
      lily: '',
      balloon: "",
      fireworks:"",
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          // const lanng = localStorage.getItem("lang");
          this.list = res.data;
          // 
          this.list.forEach(item => {
            if (item.opencode) {
              const sum = item.opencode[0] + item.opencode[1] + item.opencode[2];
              if(sum >= 11 && sum <=18){
                item.size = "A"
              }else if(sum >= 3 && sum <= 10){
                item.size = "B"
              }
              if(sum % 2 === 0){
                item.double = "C"
              }else {
                item.double = "D"
              }

              // if(sum >= 11 && sum <=18){
              //   lanng == 'zh' ? item.size = '玫瑰':lanng == 'en'? item.size = 'Rose':lanng == 'ja'? item.size = 'バラは':
              //       lanng == 'rs'? item.size = 'Роза' : lanng == 'tr'? item.size = 'Gül' : item.size = '장미'
              // }else if(sum >= 3 && sum <= 10){
              //   lanng == 'zh'? item.size = '百合':lanng == 'en'? item.size = 'Lily':lanng == 'ja'? item.size = "リリー·リリー":
              //       lanng == 'rs'? item.size = 'Лилия' : lanng == 'tr'? item.size = 'Zambak' : item.size = '백합'
              // }
              // if(sum % 2 === 0){
              //   lanng == 'zh' ? item.double = "氣球":lanng == 'en'? item.double = "Balloon":lanng == 'ja'? item.double = "气球":
              //       lanng == 'rs'? item.double = 'шарик' : lanng == 'tr'? item.double = 'Balon' : item.double = "풍선";
              // }else {
              //   lanng == 'zh'? item.double = "煙花":lanng == 'en'? item.double = "fireworks":lanng == 'ja'? item.double = "花火大会":
              //       lanng == 'rs'? item.double = 'Фейерверк' : lanng == 'tr'? item.double = 'Havai fişek' : item.double = "불꽃놀이";
              // }
            }else {
              item.double = item.size = "?"
            }
          })
         console.log(this.size, this.double,998);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
    this.rose = 'A';
    this.lily = 'B';
    this.balloon = 'C'
    this.fireworks='D'

    // const lang = localStorage.getItem("lang");
    // if (lang == 'zh') {
    //   this.rose = '玫瑰';
    //   this.lily = '百合';
    //   this.balloon = '氣球'
    //   this.fireworks='煙花'
    // } else if (lang == 'en') {
    //   this.rose = 'Rose';
    //   this.lily = 'Lily';
    //   this.balloon = 'Balloon'
    //   this.fireworks='Fireworks'
    // } else if (lang == 'ja') {
    //   this.rose = 'バラは';
    //   this.lily = "リリー·リリー";
    //   this.balloon = '气球'
    //   this.fireworks='花火大会'
    // } else if (lang == 'rs') {
    //   this.rose = 'Роза';
    //   this.lily = "Лилия";
    //   this.balloon = 'шарик'
    //   this.fireworks='Фейерверк'
    // } else if (lang == 'tr') {
    //   this.rose = 'Gül';
    //   this.lily = "Zambak";
    //   this.balloon = 'Balon'
    //   this.fireworks='Havai fişek'
    // } else {
    //   this.rose = '장미';
    //   this.lily = '백합';
    //   this.balloon = '풍선'
    //   this.fireworks='불꽃놀이'
    // }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 30px;
    min-width: 13vw;
}

.ressquareText{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  height: 7vw;
  line-height: 4vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  border-radius: 16px;
  margin-left: 20px;
  padding:  13px 30px;
  min-width: 10vw;
}
</style>
